import { useGlobalStore } from 'src/stores/useGlobalStore';
import { useUserStore } from 'src/stores/useUserStore.js';

import adminClients from './admin/Admin.Clients.routes.js';
import adminDashboard from './admin/Admin.Dashboard.routes.js';
import adminEmployes from './admin/Admin.Employes.routes.js';
import gestionHoraire from './admin/Admin.Horaire.routes.js';
import suiviRoutes from './suivi.routes.js';

const routes = [
  {
    path: '/',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [
      {
        // Home has two records rendering the same page: this one, which is
        // where every `return '/'` guard and the post-login redirect land, and
        // the named `profil` record under `/user/`, which the tab bar links to.
        // `/` matches this one first, so anything gating on the route name has
        // to accept both — hence a name here rather than an anonymous record.
        path: '',
        name: 'accueil',
        component: () => import('src/pages/Index.vue')
      } /*,
      {
        path: '/activitylog',
        component: () => import('src/pages/Activity.vue')
      }*/
    ]
  },
  {
    path: '/password-reset',
    component: () => import('src/pages/PasswordReset.vue')
  },
  {
    path: '/forgot',
    component: () => import('src/pages/Forgot.vue')
  },
  {
    path: '/login',
    component: () => import('src/pages/Login.vue')
  },
  {
    path: '/admin/',
    component: () => import('src/layouts/MainLayout.vue'),
    beforeEnter: () => {
      const userStore = useUserStore();
      return [1, 3, 4, 5, 6].includes(userStore.usergroup) ? true : '/';
    },
    children: [
      {
        path: 'presences/:date?',
        name: 'presences',
        props: true,
        component: () => import('src/pages/presences/index.vue')
      },
      {
        path: 'anomalies',
        name: 'anomalies',
        component: () => import('src/pages/anomalies/AnomalyOverviewPage.vue'),
        beforeEnter: () => {
          const userStore = useUserStore();
          return userStore.isDirecteur ? true : '/';
        }
      },
      {
        // Operator settings (`system_settings`). Same pair as the anomaly
        // overview: whoever answers for a switch being off may flip it.
        path: 'settings',
        name: 'settings',
        component: () => import('src/pages/settings/SystemSettingsPage.vue'),
        beforeEnter: () => {
          const userStore = useUserStore();
          return userStore.isDirecteur ? true : '/';
        }
      },
      {
        path: 'memos/:action(edit)?/:id(\\d+)?/:tab?',
        name: 'memos',
        component: () => import('src/pages/memos/index.vue'),
        beforeEnter: () => {
          const GlobalStore = useGlobalStore();
          return GlobalStore.serverSettings.ENABLE_MEMOS ? true : '/';
        }
      },
      {
        path: 'documents',
        name: 'documents',
        component: () => import('src/pages/documents/index.vue'),
        beforeEnter: () => {
          const userStore = useUserStore();
          const GlobalStore = useGlobalStore();
          return GlobalStore.serverSettings.ENABLE_DOCUMENTS && [1, 3, 4, 5, 6].includes(userStore.usergroup) ? true : '/';
        }
      },
      // ...Inventory,
      ...adminEmployes,
      ...adminClients,
      ...gestionHoraire,
      ...adminDashboard
    ]
  },
  {
    path: '/Dashboard/',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [...adminDashboard],
    beforeEnter: () => {
      const userStore = useUserStore();
      return [1, 3].includes(userStore.usergroup) ? true : '/';
    }
  },
  {
    path: '/user/',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [
      {
        path: '/',
        alias: 'profil',
        name: 'profil',
        component: () => import('src/pages/Index.vue')
      },
      {
        path: 'demandes',
        name: 'demandes',
        component: () => import('src/pages/user/Demandes.vue'),
        beforeEnter: () => {
          const GlobalStore = useGlobalStore();
          return GlobalStore.serverSettings.ENABLE_DEMANDES ? true : '/';
        }
      },
      {
        path: 'horaire',
        name: 'horaire',
        component: () => import('src/pages/Horaire/index.vue')
      },
      ...suiviRoutes,
      {
        path: '/formations/',
        component: () => import('src/pages/formations/List.vue'),

        beforeEnter: () => {
          const GlobalStore = useGlobalStore();
          return GlobalStore.serverSettings.ENABLE_FORMATIONS ? true : '/';
        },
        children: [
          {
            path: 'list',
            name: 'listFormation',
            component: () => import('src/pages/formations/List.vue')
          },
          /* { TODO
            path: 'edit/:id?',
            name: 'editNotif',
            component: () => import('src/pages/notif/Edit.vue'),
            props: true
          },
          {
            path: 'create',
            name: 'CreateNotif',
            component: () => import('src/pages/notif/Edit.vue'),
            props: true
          },*/
          {
            path: 'view/:id',
            name: 'viewFormation',
            component: () => import('src/pages/formations/View.vue'),
            props: true
          }
        ]
      }
    ]
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('src/pages/Error404.vue')
  }
];

export default routes;
